import { Controller } from 'stimulus';

export default class extends Controller {
  connect() {
    window.onscroll = function() {scrollFunction()};
    function scrollFunction() {
      if (document.body.scrollTop < (document.body.scrollHeight - 900)) {
        document.getElementById('promo-scroll-notification').style.display = 'block';
      } else {
        document.getElementById('promo-scroll-notification').style.display = 'none';
      }
    }
  }

}
